"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IdleMixin = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vue = _interopRequireDefault(require("vue"));

var _vuePropertyDecorator = require("vue-property-decorator");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var IdleMixin = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(IdleMixin, _Vue);

  var _super = _createSuper(IdleMixin);

  function IdleMixin() {
    var _this;

    (0, _classCallCheck2.default)(this, IdleMixin);
    _this = _super.apply(this, arguments);
    _this.idleTime = 30; // minutes

    _this.time = null;
    return _this;
  }

  (0, _createClass2.default)(IdleMixin, [{
    key: "beforeDestroy",
    value: function beforeDestroy() {
      clearTimeout(this.time);
      document.onload = null;
      document.onmousemove = null;
      document.onkeydown = null;
      /*
      document.onmousedown = null;
      document.ontouchstart = null;
      document.ontouchmove = null;
      document.onclick = null;
      document.onkeydown = null;
      document.addEventListener('scroll', null, true);
      */
    }
  }, {
    key: "created",
    value: function created() {
      this.handleInactivity();
    }
  }, {
    key: "handleInactivity",
    value: function handleInactivity() {
      var _this2 = this;

      var resetTimer = function resetTimer() {
        clearTimeout(_this2.time);
        _this2.time = setTimeout(handleTimeExpiry, _this2.idleTime * 60 * 1000);
      };

      var handleTimeExpiry = function handleTimeExpiry() {
        clearTimeout(_this2.time);

        _this2.$router.push({
          path: '/dashboard'
        });
      };

      document.onload = resetTimer;
      document.onmousemove = resetTimer;
      document.onkeydown = resetTimer;
      /*
      document.onmousedown = resetTimer; // touchscreen presses
      document.ontouchstart = resetTimer; // touchscreen swipes
      document.ontouchmove = resetTimer; // required by some devices
      document.onclick = resetTimer; // touchpad clicks
      document.onkeydown = resetTimer;
      document.addEventListener('scroll', resetTimer, true);
      */
    }
  }]);
  return IdleMixin;
}(_vue.default);

exports.IdleMixin = IdleMixin;
exports.IdleMixin = IdleMixin = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], IdleMixin);